'use strict';

import { reverseUrl } from 'utils/django';
import StateDiagram from 'incidents/utils/states';

export default function(incident) {
	var MyStateDiagram = new StateDiagram();
	MyStateDiagram.updateIncident(incident);
	incident.state = 'No response';
	incident.phoneFromUrl =  reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
}
